import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { LEAD_ROUTING_RULES_PATH } from 'src/services/api/lead-routing-rules/path';

type IDeleteLeadRoutingRuleResponse = {
    msg: string;
}

export const useDeleteLeadRoutingRule = (id?: number) => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        IDeleteLeadRoutingRuleResponse,
        IStandardErrorResponse
    >(
        () => {
            return apiClient(`${LEAD_ROUTING_RULES_PATH}/${id}`, {
                method: 'delete',
            }).json<IDeleteLeadRoutingRuleResponse>();
        }, {
            onSuccess: () => {
                addNotification('Lead routing rule deleted successfully', 'success');
                queryClient.invalidateQueries(queryKeys.leadRoutingRules);
            }, onError: (error) => {
                const errorMessage = error.msg || 'Failed to delete lead routing rule';
                addNotification(errorMessage, 'error');
            }
        });
};
